exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select {\n\tcolor: #000;\n\tfont-size: 14px;\n\tfont-family: 'PT Sans', sans-serif;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/country-selector/country-selector.component.css
// module id = 538
// module chunks = 1